import { EyePressure } from "@cur8/health-risks-calc";
import { toChartRanges } from "render/ui/presentation/RangeChart/lib/risk";
import { getMetricHistory } from "render/views/Report/AppointmentDataView/components/MetricsSection/components/metrics/utils/getMetricHistory";
import { useEyePressureMetric } from "render/views/Report/AppointmentDataView/components/MetricsSection/hooks/usePatientReportMetrics";
import { Trans } from "./trans";

type useEyePressureValuesType = {
  scanNum?: number;
  side: "left" | "right";
};

export function useEyePressureValues({
  scanNum,
  side,
}: useEyePressureValuesType) {
  const { data } = useEyePressureMetric();

  if (!data) {
    return undefined;
  }

  const { cur: curLeft, prev: prevLeft } = getMetricHistory(data.left, scanNum);
  const { cur: curRight, prev: prevRight } = getMetricHistory(
    data.right,
    scanNum
  );

  const prevEyePressureLeft = prevLeft?.unit.mmHg;
  const prevEyePressureRight = prevRight?.unit.mmHg;

  const valueLeft = curLeft?.unit.mmHg;
  const valueRight = curRight?.unit.mmHg;

  const riskRanges = EyePressure.rangesFor();

  const metricRatingLeft = curLeft && riskRanges.findRisk(curLeft.unit);
  const metricRatingRight = curRight && riskRanges.findRisk(curRight.unit);

  const curScanDateLeft = curLeft?.measurement.timestampStart;
  const curScanDateRight = curRight?.measurement.timestampStart;

  const subLabel = <Trans.MetricLabel />;

  if (side === "left") {
    return {
      subLabel,
      previousValue: prevEyePressureLeft,
      value: valueLeft,
      metricRating: metricRatingLeft,
      scanDate: curScanDateLeft,
      ranges: toChartRanges(riskRanges.entries),
    };
  }

  if (side === "right") {
    return {
      subLabel,
      previousValue: prevEyePressureRight,
      value: valueRight,
      metricRating: metricRatingRight,
      scanDate: curScanDateRight,
      ranges: toChartRanges(riskRanges.entries),
    };
  }
}
